import { render, staticRenderFns } from "./FeedbackRequestsForm.vue?vue&type=template&id=10a256f4"
import script from "./FeedbackRequestsForm.vue?vue&type=script&lang=js"
export * from "./FeedbackRequestsForm.vue?vue&type=script&lang=js"
import style0 from "./FeedbackRequestsForm.vue?vue&type=style&index=0&id=10a256f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports